import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const REASSIGN_ORDER_ITEM_STAFF = gql`
  mutation ReassignOrderItemStaff(
    $where: ReassignOrderItemStaffWhereInput!
    $data: ReassignOrderItemStaffInput!
  ) {
    reassignOrderItemStaff(where: $where, data: $data) {
      message
    }
  }
`;
